module.exports = __webpack_public_path__ + "static/img/JOBE-SCAPIN.249deb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOBE-SCAPIN.jpg
// module id = K0A7
// module chunks = 0